import * as client from '../../services/client';
import { TYPES } from '../../common/constants';
import { PATHS } from '../../common/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { startFormLoading, stopFormLoading } from './loader';

export const getUserProfileDetails = (userId) => dispatch =>{
    dispatch(startFormLoading());
    return client.getUserProfileDetails(userId).then(response =>{
        if(response.status === 200 || response.ok){
            response.json().then( responsejson => {
               
                if(responsejson.noteNotification === null){
                    responsejson.noteNotification = {
                        "serviceRequests": false,
                          "properties": false,
                          "suites": false,
                          "assets": false,
                          "inventoryItems": false,
                          "contacts": false
                      }
                }
                dispatch(userProfileDetailsFetched(responsejson))
                dispatch(stopFormLoading());
            })
           
        }
    })
}

const userProfileDetailsFetched = payload =>({
    type:TYPES.USER_PROFILE_DETAILS_FETCHED,
    payload
})

export const setSettingsForm = payload => ({
    type: TYPES.SET_SETTINGS_FORM_DATA,
    payload,
});

const updateCompanyDetailsDone = payload => ({
    type:TYPES.UPDATE_COMPANY_DETAILS_DONE,
    payload
})

export const updateCompanyDetails = data => dispatch =>{
    return client.updateCompanyDetails(data).then( response => {
        if(response.status === 200 || response.ok){
            response.json().then( responsejson =>{
                toast.success(' ⓘ Company details updated.',{autoClose:10000,position:'top-center'})
                dispatch(updateCompanyDetailsDone(responsejson.data))
            })
        }
    })
}

const updateNotificationDetailsDone = payload => ({
    type:TYPES.UPDATE_NOTIFICATION_DETAILS_DONE,
    payload
})

export const updateNotificationDetails = data => dispatch => {
    dispatch(startFormLoading())
    return client.updateNotificationDetails(data).then( response =>{
        dispatch(stopFormLoading())
        if(response.status === 200 || response.ok){
           response.json().then(
                responsejson =>{
                    toast.success(' ⓘ  Notification details updated.',{autoClose:10000,position:'top-center'})
                    dispatch(updateNotificationDetailsDone(data))
                }
            )
        }
    })
}